export const ROUTERS = {
    USER:{
        //trang chủ
        HOME:"",
        HOME_JOBSEARCH:"trang-chu-tim-viec",
        HOME_CREATECVPAGE:"trang-chu-tao-cv",
        REGISTER:"dang-ky",
        LOGIN:"dang-nhap",

        //ứng viên
        EMPLOYEE_HOMEPAGE:"trang-ung-vien",
        EMPLOYEE_PROFILE:"ho-so-ung-vien",
        EMPLOYEE_CREATECVPAGE:"trang-tao-cv",
        EMPLOYEE_JOBSEARCH:"trang-tim-viec",
        EMPLOYEE_COMPANYPAGE:"xem-trang-cong-ty/:id",

        //nha tuyen dung
        EMPLOYER_HOMEPAGE:"trang-nha-tuyen-dung",
        EMPLOYER_PROFILE:"ho-so-nha-tuyen-dung",
        EMPLOYER_COMPANYPAGE:"trang-cong-ty/:id",
        EMPLOYER_POSTJOBFORMPAGE:"dang-tin-tuyen-dung",

        //quan tri vien
        ADMIN_HOMEPAGE:"trang-quan-tri-vien"
    }
}